

const News=()=>{
    return (<>
        <h2>News</h2>
    </>)
}

export default News;